import disconnect from './disconnect'
import { getPhoneSession } from './sessionHandler'
import constants from '../../utils/constants'

let lastPingTime

const setLastPing = () => {
  lastPingTime = new Date().getTime()

  checkLastPing()
}

const checkLastPing = () => {
  const { CACOFONIX_PING_INTERVAL, JUDITE_INTERVAL_OFFSET, SECONDS_IN_MILLISECONDS } = constants

  const nextPingCheck = (CACOFONIX_PING_INTERVAL + JUDITE_INTERVAL_OFFSET) * SECONDS_IN_MILLISECONDS

  setTimeout( () => {
    const currentTime = new Date().getTime()

    const differenceBetweenTimesInSecs = (currentTime - lastPingTime) / SECONDS_IN_MILLISECONDS

    if( !isNetworkDisconnected(differenceBetweenTimesInSecs, CACOFONIX_PING_INTERVAL) ) return;

    restartConnection()
    
  }, nextPingCheck)
}

const isNetworkDisconnected = (value, maxTimeout) => value > maxTimeout

const restartConnection = () => {
  disconnect()
  
  getPhoneSession()?.start()
}

export { setLastPing, checkLastPing }